import { useCallback, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import API from "../../Network/API";
import { useEffect } from "react";
import Paginate from "../../CustomHook/Paginate";
import { Link } from "react-router-dom";
import { DC_ENERGY_FETCH_LOAD_MORE, DC_ENERGY_FETCH_SUCCESS } from "../../Reducer/DcEnergyMeterSlice";
import Env from "../../CustomHook/Env";
import { use } from "react";

export default function DcEnergy() {
    const [isLoading, setLoading] = useState(false);
    const [site_status, setStatus] = useState([]);
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [totalNoLoad, setTotalNoLoad] = useState(0);
    const [step, setStep] = useState(0);
    const dcControllerRef = useRef(null);

    const array_data = {
        page: page,
        site_id: '',
        tenant_id: '',
        type: step === 0 ? '' : step === 1 ? 'overload' : step === 2 ? 'load_disconnect' : 'no_load'    
    };

    useEffect(() => {
        all_load();
    }, []);

    useEffect(() => {

        if (page != 1) {
            array_data.page = page
            all_load()
        }

    }, [page]);

    useEffect(() => {
        setPage(1)
        array_data.page = 1
        all_load()
    }, [step]);


    const observer = useRef();
    const lastElementRef = useCallback((element) => {
        //element is the react element being referenced

        // disconnect observer set on previous last element
        if (observer.current) observer.current.disconnect();

        // if there's no more data to be fetched, don't set new observer
        if (!hasMore) return;

        // set new observer
        observer.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && hasMore) setPage((prev) => prev + 1);
        });

        // observe/monitor last element
        if (element) observer.current.observe(element);
    }, [hasMore]);

    const syncData = (name) => {
       all_load();
    }

    const all_load = () => {
        setLoading(true)
        if (dcControllerRef.current) {
            dcControllerRef.current.abort();
        }
        const controller = new AbortController();
        dcControllerRef.current = controller;
        const signal = controller.signal;

        API.get(`/v1/oauth/dc_energy_meter?page=${array_data.page}&site_id=${array_data.site_id}&tenant_id=${array_data.tenant_id}&type=${array_data.type}`, { signal }).then((response) => {
            setLoading(false);
            setHasMore(response.data.data.has_more_page)
            if (array_data.page === 1) {
                dispatch(DC_ENERGY_FETCH_SUCCESS(response.data.data))
            } else{
                dispatch(DC_ENERGY_FETCH_LOAD_MORE(response.data.data))
            }
            setStatus(response.data.data.site_status)
            setTotalNoLoad(response.data.data.no_load_sites)
        }).catch((error) => {
            setLoading(false)
        });
    }

    const selector = useSelector((state) => state.dcEnergyMeterReducer)
    const strAscending = selector?.sites.length > 0 && [...selector?.sites].sort((a, b) =>
        a.site_id > b.site_id ? 1 : -1,
    );

    return (
        <>
            <div className="row text-center  mb-2  me-1 ms-1">
                <div className="col-12 col-md-6 text-start">
                    <div class="input-group input-group-sm mt-2">
                        <button onClick={() => setStep(0)} className={`btn ${step === 0 ? 'btn-info' : 'btn-outline-primary bg-white'}  text-dark `} type="button" aria-expanded="false">
                            <i class="fa-duotone fa-bell"></i> All Sites 
                        </button>
                        <button onClick={() => setStep(1)} className={`btn ${step === 1 ? 'btn-info' : 'btn-outline-primary bg-white'}  text-dark `} type="button" aria-expanded="false">
                            <i class="fa-duotone fa-bell"></i> Overloaded (<span className="badge bg-danger">{site_status.length > 0 ? site_status[0]?.overload : 0}</span>)
                        </button>
                        <button onClick={() => setStep(2)} className={`btn ${step === 2 ? 'btn-info' : 'btn-outline-primary bg-white'}  text-dark `} type="button" aria-expanded="false">
                            <i class="fa-duotone fa-bell"></i> Load Disconnect (<span className="badge bg-danger">{site_status.length > 0 ? site_status[0]?.load_disconnect : 0}</span>)
                        </button>
                         <button onClick={() => setStep(3)} className={`btn ${step === 3 ? 'btn-info' : 'btn-outline-primary bg-white'}  text-dark`} type="button" aria-expanded="false">
                            <i class="fa-duotone fa-bell"></i> No Load (<span className="badge bg-danger">{totalNoLoad}</span>)
                        </button>

                    </div>


                </div>
                <div className="col-12 col-md-6 text-end">
                    <div className="d-flex justify-content-end mt-2">
                        <div class="input-group input-group-sm max-with-searbar">
                            <input onChange={(e) => syncData(e.target.value)} type="text" class="form-control" placeholder="search by site id...." />
                            <button class="btn btn-success" type="button"><i class="fa-light fa-search" /></button>
                        </div>
                    </div>
                </div>




                    <div className="table-responsive scrol-table-height mt-1" >

                            <table className="table thead-light rms_table table-bordered bg-white table-striped m-0 text-center">
                              
                        <thead className="text-uppercase">
                            <tr>
                                <th className="toi-primary" width={`10%`}>Last Updated</th>
                                <th className="text-center toi-primary" width={`5%`}>Site ID</th>
                                <th className="text-center toi-primary" width={`7%`}>{Env.CUSTOMER_SITE} Site ID</th>
                                <th className="text-center toi-primary">Network</th>
                                <th className="text-center toi-primary">Tenant</th>
                                <th className="text-center toi-primary">CC(A)</th>
                                <th className="text-center toi-primary">NC(A)</th>
                                <th className="text-center toi-primary">Current(A)</th>
                                <th className="text-center toi-primary">Voltage(V)</th>
                                <th className={`text-center toi-primary `}>DC(kW)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading && <div className="text-center">Loading......</div>}
                            {!selector?.loading && selector?.sites.length > 0 && strAscending?.map((site, index) => (
                                <tr className={`${site.device_live_status == 0 ? 'offline-tr' : ''}`} ref={index === selector?.sites.length - 1 ? lastElementRef : undefined}>
                                    <td>
                                        {site.update_time}
                                    </td>

                                    <td className="text-center">
                                        <Link className="fw-bold text-info" to={`/site/${site.site_id}`}>{site.site_id}</Link>
                                    </td>
                                    <td className="text-center">
                                        <Link className="fw-bold text-primary" to={`/site/${site.site_id}`}>{site.customer_site_id}</Link>
                                    </td>

                                    <td className="text-center">
                                        {site.device_live_status === 1 ?
                                            <div className="signal-bars mt1 sizing-box good four-bars">
                                                <span>
                                                    <img src="/assets/icon/6.svg" className="tower-height" alt="" />
                                                </span>
                                                <div className={`first-bar bar ${site.network_val >= 1 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`second-bar bar ${site.network_val >= 2 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`third-bar bar ${site.network_val >= 3 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`fourth-bar bar ${site.network_val >= 4 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`fifth-bar bar ${site.network_val >= 5 ? '' : 'null-color'}`}>
                                                </div>
                                            </div>
                                            :
                                            <i class="fa-solid fa-wifi-slash offline-rms-icon" title="Site not updating" />
                                        }
                                    </td>

                                    <td className="font-bold">
                                        {site.tenant_name}
                                    </td>
                                    <td className="font-bold">
                                        {site.acur}
                                    </td>
                                    <td className="font-bold">
                                        {site.bcur}
                                    </td>
                                    <td className="font-bold">
                                        {site.current}
                                    </td>
                                    <td className="font-bold">
                                        {site.voltage}
                                    </td>

                                    <td className={`font-bold ${site.is_danger == 1 ? 'text-danger' : ''}`}>
                                        {(site.load/1000).toFixed(2)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {isLoading && <div className="text-center">Loading......</div>}
                </div>
                 <p className="p-0 m-0 fs-12">Current Display 1 - {selector?.sites?.length} Record(s), {selector?.data?.total_page} Record(s) Totally</p>
            </div>
        </>
    )
}